import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AnalyticsData } from '../../../../hooks/useBoardAnalytics';

interface StaleJobsListProps {
  staleJobs: AnalyticsData['stale_jobs'];
  boardId: string;
}

function daysAgo(iso: string): number {
  try {
    return Math.floor((Date.now() - new Date(iso).getTime()) / (1000 * 60 * 60 * 24));
  } catch {
    return 0;
  }
}

export default function StaleJobsList({ staleJobs, boardId }: StaleJobsListProps) {
  const navigate = useNavigate();

  if (staleJobs.length === 0) {
    return (
      <div className="metrics-card">
        <div className="metrics-card__title" style={{ marginBottom: 12 }}>Stale Jobs</div>
        <div className="metrics-empty" style={{ padding: '24px 0' }}>No stale jobs — great work!</div>
      </div>
    );
  }

  return (
    <div className="metrics-card">
      <div className="metrics-card__header">
        <span className="metrics-card__title">Stale Jobs</span>
        <span style={{ fontSize: 12, color: '#9ca3af' }}>{staleJobs.length} job{staleJobs.length !== 1 ? 's' : ''} without update</span>
      </div>
      <div className="metrics-table-wrap">
        <table className="metrics-table">
          <thead>
            <tr>
              <th>Company</th>
              <th>Role</th>
              <th>Stage</th>
              <th>Last update</th>
            </tr>
          </thead>
          <tbody>
            {staleJobs.map((job) => (
              <tr key={job.uid}>
                <td>{job.company_name}</td>
                <td>
                  <button
                    className="metrics-table__link"
                    style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', textAlign: 'left' }}
                    onClick={() => navigate(`/crm/${boardId}/${job.uid}`)}
                  >
                    {job.job_title}
                  </button>
                </td>
                <td>{job.swimlane_name ?? '—'}</td>
                <td style={{ color: '#9ca3af' }}>{daysAgo(job.last_updated)}d ago</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
